import VehicleHistory from "./VehicleHistory";

export default VehicleHistory;
